import { createContext, FunctionComponent, useContext, useMemo, useState } from 'react';
import { singleton } from '@animavirtuality/utils';

export type DprContextValue = {
    dpr: number;
    setDpr: (dpr: number) => void;
};

export const DprContext = singleton(() => createContext<DprContextValue | null>(null));

export const useDprContext = (): DprContextValue => {
    const value = useContext(DprContext());
    if (!value) {
        throw new Error('useDprContext must be used within a DprContextProvider!');
    }
    return value;
};

export const DprContextProvider: FunctionComponent = ({ children }) => {
    const [dpr, setDpr] = useState<number>(1);

    const value = useMemo(
        () => ({
            dpr,
            setDpr,
        }),
        [dpr]
    );

    const context = DprContext();
    return <context.Provider value={value}>{children}</context.Provider>;
};
